import React from 'react';

const RegulatoryCompleted = () => {
    return (
        <></>
    );
};

export default RegulatoryCompleted;
